module.exports = "/* .aboutUsContainer{\n    background-image: url('../../../assets/images/Ashburn-2018.jpg');\n    width: 100%;\n    height: 100%;\n} */"